/* eslint-disable indent */
import React, { Fragment, useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import {
  getReportingManagersByLocationId,
  getReportingEmployeesByLocationId
} from "../../../redux/actions/reportingActions";
import { helperFunction } from "../../../constant/helper";
import {
  renderLocationFunction,
  renderReportingMangersFunction
} from "../../../constant/helper/helper";
import Card from "../../../component/card/Card";

import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import Starter from "../../../component/Starter";

const BY_MANAGERS = "BY MANAGERS";
const ALL = "ALL";

const initialState = {
  date: "",
  Filter: "",
  managerId: "",
  locationId: "",
  dataBy: "",
  onOffLocation: false,
  byTime: "inTimeDescending"
};

const ReportingManagers = () => {
  const dispatch = useDispatch();

  const loginType = localStorage.loginType;
  const [relations, setRelations] = useState([]);
  const [values, setValues] = useState(initialState);

  const { reportingEmployeesByLocation, foundManagers } = useSelector(
    (state) => state.reporting
  );
  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    setRelations(reportingEmployeesByLocation);
  }, [reportingEmployeesByLocation]);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
  }, [locationError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (values.locationId !== "" && values.dataBy === ALL) {
      dispatch(
        getReportingEmployeesByLocationId(
          values.locationId,
          loginType,
          "",
          false
        )
      );
    } else if (values.dataBy === BY_MANAGERS) {
      dispatch(
        getReportingManagersByLocationId(values.locationId, loginType)
      );
    }
  }, [values.locationId]);

  useEffect(() => {
    if (values.dataBy === BY_MANAGERS) {
      dispatch(
        getReportingManagersByLocationId(values.locationId, loginType)
      );
    }
  }, [values.dataBy]);

  useEffect(() => {
    if (values.managerId !== "") {
      dispatch(
        getReportingEmployeesByLocationId(
          values.locationId,
          loginType,
          values.managerId,
          true
        )
      );
    }
  }, [values.managerId]);

  return (
    <Starter
      topBarTitle="Reporting Managers"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Access Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Access</a>
          </li>
          <li className="breadcrumb-item active">
            Reporting Managers
          </li>
        </Fragment>
      }
    >
      <Card>
        <div className="row">
          <div className="col-3">
            <SelectInput2
              data-tip
              name="dataBy"
              isLabeled={true}
              onChange={handleInputChange}
              icon="mdi mdi-map-marker-radius"
              data-for="dataBy"
              label="Select Type"
              value={values.dataBy}
              placeholder="Select Type"
            >
              <option value={BY_MANAGERS}>{BY_MANAGERS}</option>
              <option value={ALL}>{ALL}</option>
            </SelectInput2>
          </div>
          <div className="col-3">
            {currentUser.workerDepartment === "SUPER ADMIN" &&
            currentUser.workerDesignation === "SUPER ADMIN" ? (
              <SelectInput2
                data-tip
                name="locationId"
                isLabeled={true}
                onChange={handleInputChange}
                icon="mdi mdi-map-marker-radius"
                data-for="locationId"
                label="Select Location"
                value={values.locationId}
                placeholder="Select Location"
              >
                {renderLocationFunction(locations)}
              </SelectInput2>
            ) : (
              <TextInput2
                data-tip
                type="text"
                name="text"
                readonly={true}
                data-for="locationId"
                placeholder="Location"
                icon="mdi mdi-map-marker-radius"
                value={localStorage.locationName}
              />
            )}
          </div>
          {values.dataBy === BY_MANAGERS && (
            <div className="col-3">
              <SelectInput2
                data-tip
                name="managerId"
                isLabeled={true}
                data-for="managerId"
                label="Select Manager"
                value={values.managerId}
                onChange={handleInputChange}
                placeholder="Select Manager"
                icon="mdi mdi-contacts"
              >
                {renderReportingMangersFunction(foundManagers)}
              </SelectInput2>
            </div>
          )}
        </div>
        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th>Name</th>
                <th>Department</th>
                <th>Designation</th>
                <th>Reporting Manager</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {relations.map((relationsData, parentIndex) => {
                return relationsData.children.map(
                  (childData, childIndex) => (
                    <tr key={childIndex}>
                      <td>{childData.name}</td>
                      <td>{childData.department}</td>
                      <td>{childData.designation}</td>
                      <td>{relationsData._id.parent}</td>
                    </tr>
                  )
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>
    </Starter>
  );
};

export default ReportingManagers;
